import React, { useEffect } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import { CompanyCpfCards } from "../components/CompanyCard/CompanyCpfCards";
import { useCpfHistory } from "../hooks/useCpfHistory";

const CpfHistoryPage: React.FC = () => {
    const {
        isLoading,
        History,
        totalPages,
        pageNumber,
        setPageNumber,
        filters,
        setFilters,
        setAppliedFilters,
    } = useCpfHistory();

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setAppliedFilters(filters);
        setPageNumber(1);
    };

    const updatePage = (newPage: number) => {
        window.location.hash = `page=${newPage}`;
        setPageNumber(newPage);
    };

    const getPageFromHash = () => {
        const hash = window.location.hash;
        const match = hash.match(/page=(\d+)/);
        return match ? parseInt(match[1], 10) : 1;
    };

    useEffect(() => {
        const currentHash = window.location.hash;

        const onHashChange = () => {
            setPageNumber(getPageFromHash());
        };

        if (currentHash.startsWith("#page")) {
            window.addEventListener("hashchange", onHashChange);
            return () => window.removeEventListener("hashchange", onHashChange);
        }
    }, []);

    return (
        <div
            className="d-flex"
            style={{ minHeight: "100vh", backgroundColor: "#000" }}
        >
            <Sidebar />
            <div
                className="flex-grow-1 p-4"
                style={{
                    backgroundColor: "#ffffff",
                    borderTopLeftRadius: "40px",
                    borderBottomLeftRadius: "40px",
                    padding: "32px",
                    boxShadow: "0 0 12px rgba(0,0,0,0.05)",
                }}
            >
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1
                        style={{
                            color: "#78E01D",
                            fontWeight: 600,
                            fontSize: "36px",
                            marginBottom: "24px",
                        }}
                    >
                        Históricos de Consultas (CPF)
                    </h1>
                </div>

                {/* FORM DE FILTROS */}
                <form className="row g-3 mb-4" onSubmit={handleSearch}>
                    <div className="col-md-3">
                        <label className="form-label">Protocolo</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.protocol}
                            onChange={(e) =>
                                setFilters({ ...filters, protocol: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">CPF</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.document}
                            onChange={(e) =>
                                setFilters({ ...filters, document: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">Data Início</label>
                        <input
                            type="date"
                            className="form-control"
                            value={filters.startDate}
                            onChange={(e) =>
                                setFilters({ ...filters, startDate: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">Data Fim</label>
                        <input
                            type="date"
                            className="form-control"
                            value={filters.endDate}
                            onChange={(e) =>
                                setFilters({ ...filters, endDate: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">Status</label>
                        <select
                            className="form-select"
                            value={filters.status}
                            onChange={(e) =>
                                setFilters({ ...filters, status: e.target.value })
                            }
                        >
                            <option value="">Todos</option>
                            <option value="approved">Aprovado</option>
                            <option value="disapproved">Reprovado</option>
                            <option value="completed">Finalizado</option>
                            <option value="inProcess">Em processo</option>
                            <option value="inAnalyzing">Em análise</option>
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">DeviceId</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.deviceId}
                            onChange={(e) =>
                                setFilters({ ...filters, deviceId: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">Geo Localização</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.geoLocalizacao}
                            onChange={(e) =>
                                setFilters({ ...filters, geoLocalizacao: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">IP</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.ip}
                            onChange={(e) => setFilters({ ...filters, ip: e.target.value })}
                        />
                    </div>

                    <div className="col-md-12 d-flex justify-content-end">
                        <button type="submit" className="btn btn-success px-4">
                            Pesquisar
                        </button>
                    </div>
                </form>

                {isLoading ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: "60vh" }}
                    >
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                        <small className="mt-2 text-muted">Carregando os dados...</small>
                    </div>
                ) : (
                    <CompanyCpfCards
                        page={pageNumber}
                        setPage={updatePage}
                        total={totalPages}
                        companies={History}
                    />
                )}
            </div>
        </div>
    );
};

export default CpfHistoryPage;